<template>
	<div class="catalog-header" :style="`background-color: ${theme.primary}`">
		<div class="catalog-header-top"></div>
		<div class="app-container catalog-header-content" :style="`color: ${theme.base};`">
			<div class="catalog-header-content-logo" :style="`background-color: ${theme.base};`">
				<img
					class="catalog-header-content-logo-image"
					:src="commerce.urlImage"
					:alt="`logo ${commerce.name}`"
				/>
			</div>
			<div class="catalog-header-content-data">
				<h1 class="catalog-header-content-data-name">{{ commerce.name }}</h1>
				<p
					v-if="commerce.description"
					class="catalog-header-content-data-description"
				>
					{{ commerce.description }}
				</p>
			</div>
			<div
				class="catalog-header-content-attention"
				:style="`background-color: ${attention.color}`"
				:title="attention.label"
			>
				<span>{{ attention.label }}</span>
			</div>
			<div class="catalog-header-content-searcher">
				<button
					class="catalog-header-content-searcher-button"
					type="button"
					@click="$emit('open-search')"
				>
					<img
						v-if="open"
						src="/static/images-new/icons/close.svg"
						height="18"
						alt="buscar productos"
					/>
					<img
						v-else
						src="/static/images-new/icons/icon-search.svg"
						height="23"
						alt="buscar productos"
					/>
				</button>
				<div
					:class="{ 'catalog-header-content-searcher-input-container': open }"
					:style="open ? `background-color: ${theme.base};` : ''"
				>
					<input
						class="catalog-header-content-searcher-input"
						placeholder="¿Qué buscas?"
						type="text"
						:value="search"
						@input="$emit('set-data', $event.target)"
						@keypress.enter="$emit('search-data')"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'catalog-header',
		props: {
			attention: {
				default: () => {},
				type: Object,
			},
			commerce: {
				default: () => {},
				type: Object,
			},
			open: {
				default: false,
				type: Boolean,
			},
			search: String,
			theme: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-header {
		height: 78px;
		position: fixed;
		width: 100%;
		z-index: 2;

		@media (min-width: 936px) {
			height: 128px;
		}

		&-content {
			align-items: center;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			padding: 4px 15px 9px;

			@media (min-width: 936px) {
				padding: 24px 5%;
			}

			@media (min-width: 1200px) {
				padding: 24px 0px;
			}

			&-logo {
				border-radius: 100%;
				height: 43px;
				margin-right: 12px;
				overflow: hidden;
				padding: 7px 0px;
				width: 43px;

				@media (min-width: 936px) {
					display: flex;
					height: 74px;
					margin-right: 37px;
					padding: 11px 0px;
					width: 74px;
				}

				&-image {
					margin: auto;
					max-height: 100%;
					max-width: 100%;
				}
			}

			&-data {
				max-width: min-content;
				max-width: -moz-min-content;

				@media (min-width: 936px) {
					max-width: fit-content;
					max-width: -moz-fit-content;
				}

				&-name {
					font-size: size(medium15);
					font-weight: weight(black);

					@media (min-width: 936px) {
						font-size: size(large);
					}
				}

				&-description {
					font-size: size(small);
					font-weight: weight(regular);
					margin: 1px 0px 0px !important;

					@media (min-width: 936px) {
						font-size: size(large);
						font-weight: weight(bold);
						margin: 8px 0px 0px !important;
					}
				}
			}

			&-attention {
				border-radius: 31px;
				height: 30px;
				line-height: 30px;
				margin: 0px 5px 0px auto;
				padding: 0px 9px;
				width: fit-content;
				width: -moz-fit-content;

				@media (min-width: 600px) {
					margin: 0px 18px 0px auto;
				}

				@media (min-width: 936px) {
					height: 38px;
					line-height: 38px;
					margin: 0px 0px 0px 30px;
					padding: 0px 19px;
				}

				span {
					font-size: 11px;
					font-weight: weight(bold);

					@media (min-width: 936) {
						font-size: size(medium);
					}
				}
			}

			&-searcher {
				max-width: fit-content;
				max-width: -moz-fit-content;
				width: 100%;

				@media (min-width: 936px) {
					margin-left: auto;
				}

				@media (min-width: 1200px) {
					max-width: 498px;
				}

				&-button {
					@media (min-width: 1200px) {
						display: none;
					}
				}

				&-input {
					background-color: rgba(0, 0, 0, .09);
					border: 1px solid color(newsecondary);
					border-radius: 19px;
					color: color(newsecondary);
					display: none;
					font-size: size(caption);
					font-weight: weight(medium);
					height: 38px;
					margin: auto;
					max-width: 92%;
					outline: none;
					padding: 11px 22px;
					width: 100%;

					@media (min-width: 936px) {
						background-color: rgba(255, 255, 255, .09);
						border: 1px solid color(newborder);
						color: color(white);
						max-width: 100%;
					}

					@media (min-width: 1200px) {
						display: initial;
					}

					&::placeholder {
						color: color(newsecondary);

						@media (min-width: 936px) {
							color: color(white);
						}
					}
				}

				&-input-container {
					display: flex;
					height: 74px;
					left: 0;
					position: absolute;
					right: 0;
					top: 78px;

					@media (min-width: 936px) {
						top: 128px;
					}
				}
			}
		}

		&-top {
			background-color: color(black);
			opacity: .1;
			height: 22px;
			width: 100%;

			@media (min-width: 936px) {
				height: 6px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-header.vue